const sections = document.querySelectorAll(".article__heading1");
const superSections = document.querySelectorAll(".article__superheading");
let links;

const articleNav = {
	init: (): void => {
		articleNav.navigation();
		articleNav.scrollActive();
	},

	navigation: (): void => {
		const headers = document.querySelectorAll(".article__heading1");
		const articleNavItems = document.querySelector(".article__navItems");
		const articleWrapper = document.querySelector(".article__chapterWrapper");
		articleNavItems.innerHTML = "";

		if (superSections.length > 0) {
			superSections.forEach((superheading, i) => {
				const superContainer = document.createElement("div");
				superContainer.classList.add("article__navAccordion");

				const superLink = document.createElement("div");
				superLink.classList.add("article__navSuperheading");
				superLink.innerHTML = `${superheading.innerHTML} <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.96875 4.75703L7.66875 11.4564C7.71223 11.4999 7.76386 11.5345 7.8207 11.5581C7.87754 11.5816 7.93847 11.5938 8 11.5938C8.06153 11.5938 8.12246 11.5816 8.1793 11.5581C8.23614 11.5345 8.28777 11.4999 8.33125 11.4564L15.0312 4.75703" stroke="#009EC5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
				superContainer.appendChild(superLink);

				const subList = document.createElement("div");
				subList.classList.add("article__navSublist");

				let nextSuperheading = superSections[i + 1] || null;

				headers.forEach((heading) => {
					if (
						// @ts-ignore
						heading.offsetTop > superheading.offsetTop &&
						// @ts-ignore
						(!nextSuperheading ||
							heading.offsetTop < nextSuperheading.offsetTop)
					) {
						const aElement = document.createElement("a");
						aElement.classList.add("article__navItem");
						aElement.classList.add("article__navItem");
						aElement.innerHTML = `<span>»</span> ${heading.innerHTML}`;
						aElement.href = `#${heading.id}`;
						subList.appendChild(aElement);
					}
				});

				superContainer.appendChild(subList);
				articleNavItems.appendChild(superContainer);
			});
		} else {
			headers.forEach((heading) => {
				const aElement = document.createElement("a");
				aElement.classList.add("article__navItem");
				aElement.innerHTML = `<span>»</span> ${heading.innerHTML}`;
				aElement.href = `#${heading.id}`;
				articleNavItems.appendChild(aElement);
			});
		}

		if (headers.length > 1) {
			const articleChapterLabel = document.querySelector(
				".article__chapterLabel",
			);
			articleChapterLabel?.classList.add("show");
			articleNavItems.classList.add("show");
			articleWrapper.classList.add("show");
		}

		links = document.querySelectorAll(".article__navItem");
		articleNav.setupAccordion();

		document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
			anchor.addEventListener("click", function (e) {
				e.preventDefault();
				const targetElement = document.querySelector(
					anchor.getAttribute("href"),
				);
				if (targetElement) {
					const targetPosition =
						targetElement.getBoundingClientRect().top + window.scrollY - 100;
					window.scrollTo({ top: targetPosition, behavior: "smooth" });
				}
			});
		});
	},

	setupAccordion: (): void => {
		document
			.querySelectorAll(".article__navSuperheading")
			.forEach((superLink) => {
				superLink.addEventListener("click", function (e) {
					e.preventDefault();
					// @ts-ignore
					const sublist = this.nextElementSibling;
					if (sublist) {
						sublist.classList.toggle("expanded");
						superLink.classList.toggle("expanded");
					}
				});
			});
	},

	scrollActive: (): void => {
		articleNav.changeLinkState();
		window.addEventListener("scroll", articleNav.changeLinkState);
	},

	changeLinkState: (): void => {
		if (sections.length > 0 && links && links.length > 0) {
			let index = sections.length;
			// @ts-ignore
			while (--index && window.scrollY + 50 < sections[index].offsetTop) {}
			links.forEach((link) => link.classList.remove("active"));
			links[index]?.classList.add("active");
		}
	},
};

export default articleNav;
